import tw from 'tailwind-styled-components'

export const AgendaViewPickerTab = tw.div`
  px-4
  border-b-2
  ${({ $selected }) => ($selected ? 'border-secondary' : 'border-primary')}
`
